import React from 'react';
import LegalPage from '../components/LegalPage';

const COOKIES_HTML = `
  <div class="meta">
    <strong>Effective:</strong> May 29, 2026 &nbsp;·&nbsp;
    <strong>Model:</strong> Opt-in for all non-essential cookies &nbsp;·&nbsp;
    <strong>Version:</strong> 4.0
  </div>

  <div class="summary">
    <div class="label">Cookies — Plain Terms</div>
    <h2>What you need to know</h2>
    <ul>
      <li>We ask before placing any non-essential cookie on your device.</li>
      <li>Only essential cookies run until you choose to accept more.</li>
      <li>Change your choices anytime via "Manage Cookies" in our footer.</li>
      <li>We use Google Analytics — only with your consent.</li>
      <li>No marketing cookies without your explicit opt-in.</li>
    </ul>
  </div>

  <h2>1. What Are Cookies?</h2>
  <p>Cookies are small text files placed on your device when you visit a website. Similar technologies (web beacons, pixel tags, local storage) are also covered by this policy.</p>

  <h2>2. Our Consent Model</h2>
  <div class="box box-info">
    <p>We operate an <strong>opt-in consent model</strong>. No non-essential cookies are placed until you actively accept them. You may withdraw consent at any time through "Manage Cookies" in our footer. We maintain a record of your consent choice for compliance purposes.</p>
  </div>

  <h2>3. Cookie Categories</h2>
  <h3>Strictly Necessary — Always Active</h3>
  <p>Essential for the site to function. No consent required. Includes session authentication, load balancing, payment session security, and your cookie preference record.</p>

  <h3>Analytics — Opt-In Required</h3>
  <p>Help us understand how visitors use our site (Google Analytics). Data is aggregated and anonymized where possible.</p>

  <h3>Functional — Opt-In Required</h3>
  <p>Enable personalization, language preferences, and support chat functionality.</p>

  <h3>Marketing — Opt-In Required</h3>
  <p>Track campaign effectiveness and may serve relevant content. Includes conversion pixels and social media integration.</p>

  <h2>4. Cookies We Use</h2>
  <table class="tbl">
    <tr><th>Name</th><th>Provider</th><th>Category</th><th>Purpose</th><th>Duration</th></tr>
    <tr><td>_session</td><td>GoogLyn AI</td><td>Necessary</td><td>Session management and authentication</td><td>Session</td></tr>
    <tr><td>_payment_session</td><td>GoogLyn AI</td><td>Necessary</td><td>Secure payment flow session</td><td>Session</td></tr>
    <tr><td>cookie_consent</td><td>GoogLyn AI</td><td>Necessary</td><td>Records your consent preferences</td><td>1 year</td></tr>
    <tr><td>_ga</td><td>Google</td><td>Analytics</td><td>User distinction for analytics</td><td>2 years</td></tr>
    <tr><td>_gid</td><td>Google</td><td>Analytics</td><td>Session tracking</td><td>24 hours</td></tr>
    <tr><td>_gat</td><td>Google</td><td>Analytics</td><td>Request rate throttling</td><td>1 minute</td></tr>
    <tr><td>lang_pref</td><td>GoogLyn AI</td><td>Functional</td><td>Language and display preferences</td><td>1 year</td></tr>
  </table>

  <h2>5. Managing Your Preferences</h2>
  <h3>Option 1 — Our consent centre</h3>
  <p>Click <strong>"Manage Cookies"</strong> in our footer to open the preference centre and toggle categories at any time.</p>
  <h3>Option 2 — Browser settings</h3>
  <ul>
    <li><strong>Chrome:</strong> Settings → Privacy and Security → Cookies;</li>
    <li><strong>Firefox:</strong> Settings → Privacy &amp; Security → Cookies and Site Data;</li>
    <li><strong>Safari:</strong> Preferences → Privacy → Manage Website Data;</li>
    <li><strong>Edge:</strong> Settings → Cookies and site permissions.</li>
  </ul>
  <h3>Option 3 — Industry tools</h3>
  <ul>
    <li><a href="https://youradchoices.ca" target="_blank" rel="noopener noreferrer">Digital Advertising Alliance Canada — youradchoices.ca</a></li>
    <li><a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer">Google Analytics Opt-out Add-on</a></li>
  </ul>

  <h2>6. Do Not Track</h2>
  <p>No universal standard exists for responding to DNT signals. We do not currently respond to DNT signals but will update this policy if our practice changes.</p>

  <h2>7. Updates</h2>
  <p>We review this policy whenever we add or remove cookies and at least annually. If we add new categories, we will re-request your consent.</p>

  <div class="contact">
    <div class="label">Cookie Inquiries</div>
    <p>GoogLyn AI Inc. &nbsp;·&nbsp; Toronto, Canada</p>
    <p>Email: <a href="mailto:legal@googlyn.ca">legal@googlyn.ca</a></p>
  </div>
`;

const CookiePolicy = () => (
  <LegalPage title="Cookie Policy" html={COOKIES_HTML} />
);

export default CookiePolicy;
